import { getAgentIframe, getAgentWidgetScript } from './scripts';
import CopyEmbedCode from '../../../../shared/CopyEmbedCode/CopyEmbedCode';
import React, { useEffect, useMemo, useState } from 'react';
import useGetAgentsPersonalData from '../../../../../Hooks/Agent/Getters/useGetAgentsPersonalData/useGetAgentsPersonalData';

const SCRIPT = 'javascript';

/** @returns {JSX.Element |	null} */
function CopyAgentWidgetScript() {
	const agent = useGetAgentsPersonalData();

	const [code, setCode] = useState('');
	const [codeType, setCodeType] = useState(SCRIPT);

	const javascript = useMemo(
		() => getAgentWidgetScript(agent.data?.id),
		[agent.data?.id]
	);

	const iframe = useMemo(
		() => getAgentIframe(agent.data?.id),
		[agent.data?.id]
	);

	useEffect(() => {
		if (agent.data?.id) {
			setCode(javascript);
		}
	}, [agent.data?.id]);

	/**
	 * @param {React.ChangeEvent<HTMLInputElement>} event
	 * @returns {void}
	 */
	function handleOnTypeUpdate(event) {
		const type = event.target.value;

		if (type === codeType) {
			return;
		}

		setCode(type === SCRIPT ? javascript : iframe);
		setCodeType(type);
	}

	if (!agent.data && !agent.isGettingData) {
		return null;
	}

	return (
		<CopyEmbedCode
			code={code}
			codeType={codeType}
			isGettingData={agent.isGettingData}
			onTypeUpdate={handleOnTypeUpdate}
		/>
	);
}

export default React.memo(CopyAgentWidgetScript);
